import type { ZodError } from "zod";

const SENSITIVE_PATTERNS = [/KEY/i, /SECRET/i, /TOKEN/i, /PASSWORD/i, /AUTH/i, /CREDENTIAL/i, /PRIVATE/i];

function isSensitive(key: string): boolean {
  return SENSITIVE_PATTERNS.some((pattern) => pattern.test(key));
}

function redactIfSensitive(key: string, value: unknown): string {
  if (isSensitive(key)) {
    return "<redacted>";
  }

  if (value === undefined) {
    return "undefined";
  }

  if (value === null) {
    return "null";
  }

  return String(value);
}

export function formatEnvError(error: ZodError, rawEnv: Record<string, unknown>): string {
  const lines = ["Environment validation failed:"];

  for (const issue of error.issues) {
    const key = String(issue.path[0] ?? "unknown");
    const currentValue = redactIfSensitive(key, rawEnv[key]);
    lines.push(`- ${key}: ${issue.message}. Received: ${currentValue}`);
  }

  return lines.join("\n");
}
